import React, { useState, useRef, useEffect } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import { Figure } from "../shared/utils/Figure";
import endpoints from "../../utility/endpoints";


const FloatingChatBot = () => {
  const router = useRouter();
  const iconRef = useRef(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const [dragging, setDragging] = useState(false);
  const [rel, setRel] = useState({ x: 0, y: 0 });

  const handleMouseDown = (e) => {
    const rect = iconRef.current.getBoundingClientRect();
    setDragging(true);
    setRel({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
    e.preventDefault();
  };

  const handleMouseMove = (e) => {
    if (!dragging) return;
    setPosition({
      x: e.clientX - rel.x,
      y: e.clientY - rel.y,
    });
    e.preventDefault();
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  useEffect(() => {
    if (dragging) {
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
    } else {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    }
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [dragging]);

  // Initialize position to bottom right corner
  useEffect(() => {
    const offsetX = 50;
    const offsetY = 40;
    const iconSize = 56;

    const defaultX = window.innerWidth - iconSize - offsetX;
    const defaultY = window.innerHeight - iconSize - offsetY;

    setPosition({ x: defaultX, y: defaultY });
  }, []);

   const handleClick = () => {
    window.open(`${endpoints.redirectUriLogin}/bernard-chat`);
  };

  return (
    <>
      <div
        ref={iconRef}
        onMouseDown={handleMouseDown}
        onClick={handleClick}
        className="floating-icon"
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
          position: "fixed",
          width: "70px",
          height: "70px",
          borderRadius: "9999px",
          backgroundColor: "#485acd",
          display: router.pathname === "/bernard-chat" ? "none" : "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          zIndex: 9999,
        }}
        title="Hi! I am Bernard"
      >
        <Figure className="w-full h-full rouned-full">
          <Image
            src="/assets/images/bernard.jpeg"
            alt="ChatBot"
            width={56}
            height={56}
            className="rounded-full"
          />
        </Figure>
      </div>

      <style jsx>{`
        @keyframes float {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-6px);
          }
          100% {
            transform: translateY(0px);
          }
        }

        .floating-icon {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </>
  );
};

export default FloatingChatBot;
